import React from 'react';

import {ConvertorFieldTypeToDataType} from 'src/components/data-types/constants';
import {FieldType} from 'src/openapi/models/FieldType';

import {DropdownMenuItem} from '@pb/kit-component-dropdown-menu';

import {ItemsTypeList} from './items-type-list';

type Props = {
    handler: (value: string, item?: string) => void,
};

export const DataTypeList = ({handler}: Props) => {
    const {REFERENCE, ...itemsTypeList} = ConvertorFieldTypeToDataType;

    return (
        <>
            {Object.entries(itemsTypeList)
                .toSorted((a, b) => a[0].localeCompare(b[0]))
                .map(([dataTypeName, dataTypeValue]) => {
                    if (dataTypeName === FieldType.ARRAY || dataTypeName === FieldType.ARRAY_UNIQUE) {
                        return (
                            <DropdownMenuItem key={dataTypeName} caption={dataTypeValue}>
                                <ItemsTypeList dataType={dataTypeName} handler={handler}/>
                            </DropdownMenuItem>
                        );
                    }
                    return (
                        <DropdownMenuItem
                            key={dataTypeName}
                            caption={dataTypeValue}
                            onClick={() => handler(dataTypeName, '')}
                        />
                    );
                })}
        </>
    );
};
